export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0033s_0000_Black-&-White-22.368c548d.png";